/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-inner-declarations */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { isNil } from 'lodash';
import moment from 'moment';
import { setNotification, operatorTyping } from 'utils';
import * as JobResultActions from '../actions/jobResultActions';
import * as JobResultApi from '../api/jobResultApi';
import * as JobResultTypes from '../types/jobResultTypes';

const getLayout = state => state.layout;
const getJobResult = state => state.jobResult;

// L O A D   J O B   R E S U L T
function* loadJobResultSaga(action) {
    try {
        const prevMonth = moment().subtract(3, 'months');
        const startDate = prevMonth.format('YYYY-MM-DD 00:00:00');
        const nowDate = moment().format('YYYY-MM-DD 23:59:59');

        const jobResult = yield select(getJobResult);
        const { locale } = yield select(getLayout);

        const { offset, limit, filters, checked, sort } = jobResult;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['job', 'order_item', 'form_version', 'form', 'rolls_out']),
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'quantity') {
                params.sort_by = JSON.stringify({ quantity: sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            } else if (sort.key === 'job_palette_number') {
                params.sort_by = JSON.stringify({ job_palette_number: sortInt });
            }
        }

        yield put(JobResultActions.setCheckedJobResult([]));
        yield put(JobResultActions.setCheckedJobResultRecord([]));

        const filterParams = {
            created_at: { between: [startDate, nowDate] },
        };

        if (filters.id !== '') {
            filterParams.join = {
                ...filterParams.join,
                job_palette_number: operatorTyping(filters.id.trim()),
            };
        }

        if (filters.job !== '') {
            filterParams.join = {
                ...filterParams.join,
                'job.job_number': operatorTyping(filters.job.trim()),
            };
        }

        if (filters.form_version_id !== '') {
            filterParams.join = {
                ...filterParams.join,
                'form_version.form_version_number': operatorTyping(filters.form_version_id.trim()),
            };
        }

        if (filters.form_id !== '') {
            filterParams.join = {
                ...filterParams.join,
                'form.form_number': operatorTyping(filters.form_id.trim()),
            };
        }

        if (filters.design_id !== '') {
            filterParams.join = {
                ...filterParams.join,
                'order_item.design_id': operatorTyping(filters.design_id.trim()),
            };
        }

        if (filters.order_item_id !== '') {
            filterParams.join = {
                ...filterParams.join,
                'order_item.order_item_number': operatorTyping(filters.order_item_id.trim()),
            };
        }

        if (filters.order_id !== '') {
            filterParams.join = {
                ...filterParams.join,
                'order_item.order_number': operatorTyping(filters.order_id.trim()),
            };
        }

        if (filters.po_number !== '') {
            filterParams.join = {
                ...filterParams.join,
                'order_item.po_number': operatorTyping(filters.po_number.trim()),
            };
        }

        if (filters.roller_barcode !== '') {
            filterParams.join = {
                ...filterParams.join,
                'rolls_out.rolls_out_barcode': operatorTyping(filters.roller_barcode.trim()),
            };
        }

        if (filters.paletteNumber !== '') {
            filterParams.palette_number = filters.paletteNumber.trim();
        }

        if (filters.palette !== '') {
            filterParams.palette_bar_code = operatorTyping(filters.palette.trim());

            if (filters.palette === 'null') {
                filterParams.palette_bar_code = null;
            }
        }

        if (filters.machine_ids !== undefined) {
            filterParams.machine_ids = filters.machine_ids;
        }

        if (filters.status) {
            if (filters.status === 'NOT_DONE') {
                filterParams.state = ['WAITING_FOR_MANUFACTURING', 'PLANNED', 'IN_PROGRESS'];
            } else {
                filterParams.state = filters.status;
            }
        }

        params.filter = JSON.stringify(filterParams);
        const result = yield JobResultApi.getJobResultApi(params);

        yield put(JobResultActions.loadJobResultRes(result.data));
        yield put(JobResultActions.setCheckedJobResultRecord(result.data.hits.filter(hit => checked.ids.includes(hit._id))));

        if (action.jps) {
            const { hits } = result.data;

            const jps = hits.filter(hit => action.jps.map(jp => jp.job_palette_id).includes(hit._id));

            jps.forEach((jp) => {
                if (isNil(jp.palette_number)) {
                    setNotification('error', locale, 'global.error', `Cannot add job result ${jp.job_palette_number} to palette`, { noTranslateMsg: true, duration: 0 });
                }
            });
        }
    } catch (e) {
        console.log(e);
        yield put(JobResultActions.loadJobResultErr());
    }
}

export function* loadJobResultWatcher() {
    yield takeLatest(JobResultTypes.LOAD_JOB_RESULT, loadJobResultSaga);
}
// L O A D   J O B   R E S U L T

// R E S E T   J O B   R E S U L T   F I L T E R S
function* resetJobResultFiltersSaga() {
    try {
        const jobResult = yield select(getJobResult);

        const { offset, limit } = jobResult;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['job', 'order_item', 'form_version', 'form']),
        };

        const result = yield JobResultApi.getJobResultApi(params);

        yield put(JobResultActions.resetJobResultFiltersRes(result.data));
    } catch (e) {
        yield put(JobResultActions.loadJobResultErr());
    }
}

export function* resetJobResultFiltersWatcher() {
    yield takeLatest(JobResultTypes.RESET_JOB_RESULT_FILTERS, resetJobResultFiltersSaga);
}
// R E S E T   J O B   R E S U L T   F I L T E R S

// T O G G L E   J O B   R E S U L T   S T E P S
function* toggleJobResultStepsSaga(action) {
    const jobResult = yield select(getJobResult);
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        let readyStepsCount = 0;

        const params = {
            bulk: [],
        };

        function isAlreadyFinished(jp) {
            return jp.next_machine === null && jp.current_machine === null;
        }

        function isReadyToStart(jp) {
            return jp.next_machine !== null;
        }

        function isReadyToStop(jp) {
            return jp.current_machine !== null;
        }

        function buildToggleParameters(readyJobResults) {
            if (readyStepsCount !== 0) {
                readyJobResults.forEach((jp) => {
                    params.bulk.push({
                        job_palette_id: jp._id,
                        machine_id: action.data === 'start' ? jp.next_machine : jp.current_machine,
                        state: action.data,
                    });
                });
            }
        }

        if (jobResult.checked.selected.every(isAlreadyFinished)) {
            setNotification('error', locale, 'global.error', 'jobResult.notification.toggleSteps.alreadyFinished.error');
        } else {
            if (action.data === 'start') {
                const readyToStartJobResults = jobResult.checked.selected.filter(isReadyToStart);
                readyStepsCount = readyToStartJobResults.length;
                buildToggleParameters(readyToStartJobResults);
            } else if (action.data === 'end') {
                const readyToStopJobResults = jobResult.checked.selected.filter(isReadyToStop);
                readyStepsCount = readyToStopJobResults.length;
                buildToggleParameters(readyToStopJobResults);
            }

            if (readyStepsCount === 0) {
                setNotification('error', locale, 'global.error', `jobResult.notification.toggleSteps.already.${action.data}.error`);
            } else {
                const result = yield JobResultApi.toggleJobResultStepsApi(params);
                if (result.status === 202) {
                    setNotification('success', locale, 'global.success', `jobResult.notification.toggleSteps.${action.data}.success`, { number: readyStepsCount });
                    yield call(loadJobResultSaga, {});
                } else {
                    const error = yield result.json();
                    setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
                }
            }
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', `jobResult.notification.toggleSteps.${action.data}.error`);
    }
}

export function* toggleJobResultStepsWatcher() {
    yield takeLatest(JobResultTypes.TOGGLE_JOB_RESULT_STEPS, toggleJobResultStepsSaga);
}
// T O G G L E   J O B   R E S U L T   S T E P S

// P R I N T   P A L E T T E
export function* printPaletteSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {};

        const filterParams = {
            _id: action.data,
        };

        params.filter = JSON.stringify(filterParams);

        const result = yield JobResultApi.getJobResultApi(params);

        if (result.status === 200) {
            window.open(`${process.env.REACT_APP_CDN}job-palettes/${result.data.hits[0].pdf_file}`, '_blank');
            yield put(JobResultActions.printPaletteRes());
        } else {
            setNotification('error', locale, 'global.error', 'jobResult.notification.printPalette.error');
            yield put(JobResultActions.printPaletteErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'jobResult.notification.printPalette.error');
        yield put(JobResultActions.printPaletteErr());
    }
}

export function* printPaletteWatcher() {
    yield takeLatest(JobResultTypes.PRINT_PALETTE, printPaletteSaga);
}
// P R I N T   P A L E T T E

// A D D   N E W   P A L E T T E
function* addNewPaletteSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield JobResultApi.addNewPaletteApi(action.data);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'jobResult.notification.addNewPalette.success');
            yield put(JobResultActions.setJobResultSort('created_at', 'desc'));

            if (action.data.print) {
                yield call(printPaletteSaga, action.data.items[0].job_palette_id);
            }
            yield call(loadJobResultSaga, { jps: action.data.items });
            yield put(JobResultActions.addNewPaletteRes());
        } else {
            yield put(JobResultActions.addNewPaletteErr());
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'jobResult.notification.addNewPalette.error');
        yield put(JobResultActions.addNewPaletteErr());
        console.log(e);
    }
}

export function* addNewPaletteWatcher() {
    yield takeLatest(JobResultTypes.ADD_NEW_PALETTE, addNewPaletteSaga);
}
// A D D   N E W   P A L E T T E


// U P D A T E   J O B   R E S U L T S
function* updateJobResultsSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield JobResultApi.updateJobResultsApi(action.data);

        if (result.status === 202) {
            yield put(JobResultActions.updateJobResultsRes(true, false));
            yield call(loadJobResultSaga, {});
            yield put(JobResultActions.updateJobResultsRes(false, true));
            yield delay(1000);
            yield put(JobResultActions.updateJobResultsRes(false, false));

            setNotification('success', locale, 'global.success', 'jobResult.notification.edit.quantity.job.results.success');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(JobResultActions.updateJobResultsErr());
        }
    } catch (e) {
        yield put(JobResultActions.updateJobResultsErr());
        setNotification('error', locale, 'global.error', 'jobResult.notification.edit.quantity.job.results.error');
        console.log(e);
    }
}

export function* updateJobResultsWatcher() {
    yield takeLatest(JobResultTypes.UPDATE_JOB_RESULTS, updateJobResultsSaga);
}
// U P D A T E   J O B   R E S U L T S

// U P D A T E   J O B   R E S U L T S
function* forcePrintPaletteSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield JobResultApi.forcePrintPaletteApi(action.data);

        if (result.status === 202) {
            yield put(JobResultActions.forcePrintPaletteRes(true, false));
            yield put(JobResultActions.forcePrintPaletteRes(false, true));
            yield put(JobResultActions.forcePrintPaletteRes(false, false));
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(JobResultActions.forcePrintPaletteErr());
        }
    } catch (e) {
        yield put(JobResultActions.forcePrintPaletteErr());
        console.log(e);
    }
}

export function* forcePrintPaletteWatcher() {
    yield takeLatest(JobResultTypes.FORCE_PRINT_PALETTE, forcePrintPaletteSaga);
}
// U P D A T E   J O B   R E S U L T S

// D E L E T E   J O B   R E S U L T
function* deleteJobResultSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield JobResultApi.deleteJobResultApi({ bulk: [{ job_palette_id: action.id }] });

        if (result.status === 202) {
            yield put(JobResultActions.deleteJobResultRes());
            yield call(loadJobResultSaga, {});
            setNotification('success', locale, 'global.success', 'jobResult.notification.deleteJobResult.success');
        } else {
            yield put(JobResultActions.deleteJobResultErr());
            setNotification('error', locale, 'global.error', 'jobResult.notification.deleteJobResult.error');
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'jobResult.notification.deleteJobResult.error');
        yield put(JobResultActions.deleteJobResultErr());
        console.log(e);
    }
}

export function* deleteJobResultWatcher() {
    yield takeLatest(JobResultTypes.DELETE_JOB_RESULT, deleteJobResultSaga);
}
// D E L E T E   J O B   R E S U L T

// G E N E R A T E   T E M P O R A R Y   P A P E R
function* generateTemporaryPaperSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield JobResultApi.generateTemporaryPaperApi({ job_palette_ids: action.data.map(jr => jr._id) });
        if (result.status === 200) {
            const body = yield result.text();
            window.open(`${process.env.REACT_APP_CDN}${body.replace(/"/g, '')}`, '_blank');
            yield put(JobResultActions.generateTemporaryPaperRes());
        } else {
            yield put(JobResultActions.generateTemporaryPaperErr());
            setNotification('error', locale, 'global.error', 'jobResult.notification.temporaryPaper.error');
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'jobResult.notification.temporaryPaper.error');
        yield put(JobResultActions.generateTemporaryPaperErr());
        console.log(e);
    }
}

export function* generateTemporaryPaperWatcher() {
    yield takeLatest(JobResultTypes.GENERATE_TEMPORARY_PAPER, generateTemporaryPaperSaga);
}
// G E N E R A T E   T E M P O R A R Y   P A P E R
